import { html, rune, UnsafeHtml, View } from 'rune-ts';
import klass from './SolutionSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';
import { getResizedUrl } from '../../../../../shared/util/image';

export type SolutionCardProps = {
  title: UnsafeHtml | string;
  imageUrl: string;
};

export class SolutionCard extends View<SolutionCardProps> {
  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const { title, imageUrl } = this.data;

    return html`
      <div class="${klass.solution_card}">
        <div class="${klass.solution_image}">
          <img
            src="${getResizedUrl({
              url: imageUrl,
              width: 1920 * 2,
              format: 'webp',
              quality: 85,
            })}"
            alt="ip 커머스 예시 이미지"
          />
        </div>
        <div class="${klass.card_title} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_bold' })}">
          ${title}
        </div>
      </div>
    `;
  }
}
